/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MailParamsProcessReminderEmployeeTemplateData } from '../../models/mail-params-process-reminder-employee-template-data';
import { ResponseObject } from '../../models/response-object';

export interface SendProcessReminderEmployeeMail$Params {
      body: MailParamsProcessReminderEmployeeTemplateData
}

export function sendProcessReminderEmployeeMail(http: HttpClient, rootUrl: string, params: SendProcessReminderEmployeeMail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseObject>> {
  const rb = new RequestBuilder(rootUrl, sendProcessReminderEmployeeMail.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseObject>;
    })
  );
}

sendProcessReminderEmployeeMail.PATH = '/sendMail/process-reminder-employee';
